import { BaseViewModel } from "@/models/core/BaseViewModel";

export class DocumentModel extends BaseViewModel {
  description: string = "";
  name: string = "";
  url: string = "";
}
